import React from "react";
import { EditUserPage } from "./edit-page";

export default props => (
  <EditUserPage backTo="/users" username={props.match.params.id} />
);



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/pages/admin/users/Edit.js